import React from 'react';
import ReactDOM from 'react-dom/client';
import Router from './router';
import { DataProvider } from './DataContext'; // ✅ добавляем контекст
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <DataProvider>
      <Router />
    </DataProvider>
  </React.StrictMode>
);
